import React, { useState, useRef, useEffect } from 'react';
import solidbackgroundimg from "../assets/solidbackgroundimg.png";
import CustomMarkupGrid from '../Module/LiveEvent/LiveEventCustomMarkupGrid';
import CustomButton from './CustomButton';
import { Translate } from './LanguageChanger';
import upcomingImg from '../assets/upcoming.png';
// import { fetchContent } from '../services/api';
import MenuScreen from './MenuScreen';
import logoutIcon from '../assets/Logout-Icon.png';
import ModalScreen from './ModalScreen';
import DetailsScreen from '../Module/LiveEvent/LiveEventDetailsScreen';
import { getLiveSection, logoutUser } from '../services/services';
import { sendTestMatomoEvent } from "../Analytics/MatomoManager/matomoTest";
import { AppContext } from "../AppContext";
import { logEvent, logFocusEvent} from '../Analytics/MatomoManager/loger';
import { useContext } from "react";
import LoaderScreen from './LoaderScreen';

let setFocus;
let resolution = window.RESOLUTION;

const LiveTv = ({ dsply = "block", navigate, isLogedIn, FocusHandler, IsLiveEvent }) => {
    const [state, setState] = useState({
        loading: true,
        liveEventData: [],
        liveTvData: [],
        shouldFocusToGrid: true,
        shouldCloseMenu: true,
        shouldFocusLiveEventsBTN: false,
        shouldShowModal: false,
        errTitle: "",
        errDescription: "",
        errIcon: "",
        button: ["Logout", "Cancel"],
        iconWdth: "",
        iconHeight: "",
    });

    const [screen, setScreen] = useState();
    const [data, setData] = useState({});
    const [rememberRowFocus, setRememberRowFocus] = useState(null);
    const [rememberColFocus, setRememberColFocus] = useState(null);
    const navigateToScreen = (screen, data = {}) => {
        setScreen(screen);
        setData(data);
    };
    const { sourceContext, setSourceContext } = useContext(AppContext);


    const {
        loading,
        liveEventData,
        liveTvData,
        shouldFocusToGrid,
        shouldFocusLiveEventsBTN,
        shouldCloseMenu,
        shouldShowModal,
        errTitle,
        errDescription,
        errIcon,
        button,
        iconWdth,
        iconHeight,
    } = state;

    console.log("liveEventData...", liveEventData);

    useEffect(() => {
        loadLiveData();
        // if(data && data.length > 0 && dsply){loadLiveData();}
        // return () => {  
        // };
    }, [dsply]);

    useEffect(() => {
        setSourceContext("Live")
        localStorage.setItem("pageName", "Live-Event");
        sendTestMatomoEvent({
            eventCategory: "Page",
            eventAction: "View",
            eventName: "LiveEvent",
            url: "live-event",
        });
    }, []);

    const loadLiveData = async () => {
        console.log("getLiveEvents Data.......");
        setState((prevState) => ({
            ...prevState,
            loading: true,
        }));
        const user_details = JSON.parse(localStorage.getItem("user_details"));
        const userId = localStorage.getItem("profileId");
        const getCountry = localStorage.getItem("country");

        let myHeaders = {
            // is_home_page: "1",
            platform: "0",
            iskid: "0",
            isDefault: "0",
            country: getCountry,
            ageGroup: "12",
            // Langid: "1",
            // 
            // profileid: userId,
            Authorization: `Bearer ${localStorage.getItem("JWTToken")}`,
            "Content-Type": "application/json",
        };
        try {
            // const [getLiveEvents] = await Promise.all([
            //     fetchContent(
            //         `/V1/getLiveSection/0/0/0/India/1`,
            //         "GET",
            //         myHeaders
            //     ).catch((error) => null),
            // ]);
            const getLiveEvents = await getLiveSection(getCountry)
            console.log("getLiveEvents Data.......", getLiveEvents.data);
            //   FocusHandler("LiveEvent", getLiveEvents.data);
            setState((prevState) => ({
                ...prevState,
                loading:false,
                liveTvData: getLiveEvents.data,
            }));
            // loadData();
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    const loadData = () => {
        console.log("loadData Data.......", liveTvData);
        setState((prevState) => ({
            ...prevState,
            loading: true,
        }));
        let filteredData = [];
        let shows = [];
        for (var i = 0; i < liveTvData.length; i++) {
            shows = []
            if (liveTvData[i].list.length > 0) {
                const newObject = liveTvData[i].list.map(item => ({ ...item, playlist_type: liveTvData[i].playlist_type }));
                shows.push(...newObject);
                let obj = {
                    shows: shows,
                    list: shows,
                    // shows:data[i].list,                  
                    // list:data[i].list,
                    above_recomendation: liveTvData[i].above_recomendation,
                    ads_duration: liveTvData[i].ads_duration,
                    banner: liveTvData[i].banner,
                    below_recomendation: liveTvData[i].below_recomendation,
                    cache_duration: liveTvData[i].cache_duration,
                    category_id: liveTvData[i].category_id,
                    component_action: liveTvData[i].component_action,
                    genres_id: liveTvData[i].genres_id,
                    id: liveTvData[i].id,
                    is_repeated: liveTvData[i].is_repeated,
                    layout: liveTvData[i].layout,
                    playlist_type: liveTvData[i].playlist_type,
                    genres_name: liveTvData[i].playlist_type,
                    playlist_type_id: liveTvData[i].playlist_type_id,
                    publisher_id: liveTvData[i].publisher_id,
                    tag_id: liveTvData[i].tag_id,
                    title: liveTvData[i].title,
                    title_appearance: liveTvData[i].title_appearance,
                    tv_ads_appearance: liveTvData[i].tv_ads_appearance,
                }
                filteredData.push(obj)
            }
        }

        console.log("filteredData Data.......", filteredData);
        setState((prevState) => ({
            ...prevState,
            loading: false,
            liveEventData: filteredData
        }));
        setFocus(dsply);
        // setFocus(true);
    };

    const modalCANCELButtonHandler = () => {
        // MenuScreen.ReseTfocus(-1);
        MenuScreen.ReseTfocus(4);
        setState((prevState) => ({
            ...prevState,
            shouldShowModal: false,
            shouldCloseMenu: false,
            shouldFocusToGrid: true,
        }));
        MenuScreen.SetFocus(true);
    };

    const modalOKButtonHandler = (action) => {
        switch (action) {
            case "Login":
                navigate("LoginScreen");
                break;
            case "Logout":
                console.log("Logout....");
                localStorage.removeItem("JWTToken");
                localStorage.removeItem("userInfo");
                const getCountry = localStorage.getItem("country");
                let headers = {
                    iskid: "0",
                    Langid: "1",
                    "Content-Type": "application/json",
                    country: getCountry,
                };
                // Promise.all([fetchContent("/V1/logout", "POST", headers)]);
                logoutUser()
                localStorage.clear();
                window.appReload();
                MenuScreen.ReseTfocus(4);
                MenuScreen.SetFocus(true);
                handleMenuselection("Login");
                break;
            case "Yes":
                console.log("exit application..");
                exitApplication();
                // window.close();
                break;
            default:
                break;
        }
    };
    const exitApplication = () => {
        // console.log("exitApp...");
        if (window.tizen) {
            sendTestMatomoEvent({ eventCategory: `App`, eventAction: "End" });
          window.tizen.application.getCurrentApplication().exit();
        }else {
            sendTestMatomoEvent({ eventCategory: `App`, eventAction: "End" });
            window.close();
        }
    };

    const handleRightButton = () => {
        setState((prevState) => ({
            ...prevState,
            shouldCloseMenu: true,
            //   shouldFocus: true,
            shouldFocusToGrid: true,
            shouldFocusToScreenBG: false,
            //   dsply: "none,",
            shouldFocusToRowList: false,
            //   liveEventData: null,
        }));
        MenuScreen.SetFocus(true);
    };

    const handleMenuselection = (selectedMenu) => {
        switch (selectedMenu) {
            case "Login":
                navigate("LoginScreen");
                break;
            case "Profile":
                navigate("ProfileScreen");
                break;
            case "Search":
                navigate("SearchScreen");
                break;
            case "Live":
                navigate("LiveScreen");
                break;
            case "LiveEvents":
                navigate("LiveEventsScreen");
                break;
            case "Home":
                navigate("HomePage");
                break;
            case "Watchlist":
                break;
            case "Categories":
                navigate("CategoryScreen");
                break;
            case "Settings":
                navigate("SettingsScreen");
                break;
            case "Logout":
                break;
            default:
                break;
        }
    };

    const handleLogout = (p) => {
        setState((prevState) => ({
            ...prevState,
            shouldCloseMenu: true,
            shouldShowModal: true,
            errTitle: "Logout",
            errDescription: "cofirm-logout",
            errIcon: logoutIcon,
            iconWdth: "109px",
            iconHeight: "109px",
            button: ["Logout", "Cancel"],
        }));
        MenuScreen.SetFocus(true);
    };

    const handleLogin = (p) => {
        // console.log("homescreen....", shouldShowError);
        setState((prevState) => ({
            ...prevState,
            shouldCloseMenu: true,
            shouldShowError: true,
            errTitle: "Login to Continue",
            errDescription: "LoginContinue",
            //   errIcon: loginimg,
            iconWdth: "109px",
            iconHeight: "109px",
            button: ["Login", "Cancel"],
        }));
        MenuScreen.SetFocus(true);
    };

    const handleExit = () => {
        setState((prevState) => ({
            ...prevState,
            shouldCloseMenu: true,
            shouldShowModal: true,
            // shouldShowError: true,
            errTitle: "Exit",
            errDescription: "ExitMsg",
            errIcon: logoutIcon,
            iconWdth: "109px",
            iconHeight: "109px",
            button: ["Yes", "No"],
        }));
        MenuScreen.SetFocus(true);
    };

    useEffect(() => {
        loadData();
    }, [liveTvData]);

    const handleLiveEventKey = (event) => {
    // Logger added
    logFocusEvent("Live_TV_Triggered", {
        pressedKey: event.keyCode,
    });

    switch (event.keyCode) {
        case 40:
            setState((prevState) => ({
                ...prevState,
                shouldFocusToGrid: true,
                shouldFocusLiveEventsBTN: false
            }));
            break;
        case 8:
        case 10009:
        case 461:
            console.log("back key....");
            setState((prevState) => ({
                ...prevState,
                shouldFocusToGrid: false,
                shouldFocusLiveEventsBTN: false
            }));
            FocusHandler("LiveEventBackKey");
            window.removeEventListener("keydown", handleLiveEventKey);
            break;
        default:
            break;
    }
};

    setFocus = (p) => {
        if (p === true) {
            window.addEventListener("keydown", handleLiveEventKey);
        } else {
            window.removeEventListener("keydown", handleLiveEventKey)
        }
    };

    const handleBackButton = () => {
        console.log("LineEvents back key....");
        setState((prevState) => ({
            ...prevState,
            shouldFocusToGrid: false,
            shouldFocusToRowList: false,
            shouldCloseMenu: false,
            shouldFocusToTab: false,
            // shouldShowModal: true
        }));
        MenuScreen.SetFocus(false);
        // FocusHandler("LiveEventBackKey");
        // console.log("back key....");
        // navigateToScreen("HomeScreen", true);
    };

    const handleMarkupGridUPButton = () => {
        console.log("handleMarkupGridUPButton...");

    };

    const handLeMarkupGridLeftButton = () => {
        console.log("handLeMarkupGridLeftButton...");
    };

    const handleMarkupGridOKButton = (selectedItemInfo) => {
        console.log("selectedItemInfo...", selectedItemInfo);
        window.removeEventListener("keydown", handleLiveEventKey);
        navigateToScreen("DetailsScreen", selectedItemInfo);

    };

    const handleBack = (screenName) => {
        console.log("screenName..", screenName);
        setSourceContext("LiveEvent")
        setState((prevState) => ({
            ...prevState,
            shouldFocusToGrid: true,
        }));
        setScreen("CategoryScreen", {});
    };

    const detailToDetail = (recommendationItem) => {
        console.log('naveen :: detailToDetail', recommendationItem);
        // setData(recommendationItem);
        // setScreen("DetailsScreen")
        setState((prevState) => ({
            ...prevState,
            loading: true,
        }));
        navigateToScreen("", recommendationItem);
        setTimeout(function () {
            setState((prevState) => ({
                ...prevState,
                loading: false,
            }));
            navigateToScreen("DetailsScreen", recommendationItem)
        }, 100)

    }

    const styles = {
        applanguageContainer: {
            background: `url(${solidbackgroundimg})`,
            position: 'absolute',
            display: dsply,
            flexDirection: "column",
            width: "100vw",
            height: "100vh",
            backgroundSize: "cover",
            backgroundPosition: "center", // Center the background image
            backgroundRepeat: "no-repeat", // Do not repeat the background image
            opacity: 1
        },
    };
    if (screen !== "DetailsScreen") {
        return (//width:1780px,marginLeft:115px;
            <div style={styles.applanguageContainer}>
                 {loading && <LoaderScreen />}
                <div style={{ width: '93vw', height: '2px', background: '#0E1653', position: 'absolute', marginLeft: '7rem', marginTop: '100px', opacity: '0.5' }}></div>
                <div style={{ position: 'absolute' }}>
                    <span
                        style={{
                        position: "absolute",
                        top: resolution === "FHD" ? "47px" : "32px",
                        left: resolution === "FHD" ? "821px" : "821px",
                        // left: "50%",
                        width: resolution === "FHD" ? "201px" : "169px",
                        height: resolution === "FHD" ? "45px" : "43px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        textAlign: "center",
                        background: "none",
                        borderStyle: "none",
                        fontSize: resolution === "FHD" ? "40px" : "30px",
                        color: "#fff", // Make sure text is visible
                        zIndex: 10,
                        }}
                    >
                        <Translate langKey={'Live_Events'}/>
                    </span>
                    </div>
                <div style={{position: 'absolute', width: '100%', height: '940px', overflow: 'hidden', marginLeft: '7rem', marginTop: '205px' }}>
                    <CustomMarkupGrid
                        rowWidth={1802}
                        rowHeight={358}
                        gapBetweenRow={35}
                        columnWidth={228}
                        columnHeight={291}
                        gapBetweenColumn={30}
                        itemWidth={228}
                        itemHeight={291}
                        numRows={3} // Default to create only two rows by default
                        fontSize="32px"
                        fontColor="#FFFFFF"
                        selectionStyle="border" // or "zoom"
                        numColumns={7} // Default number of columns
                        shouldFocus={shouldFocusToGrid}
                        data={liveEventData}
                        IsLiveEvent={IsLiveEvent}
                        marginLeft={0}
                        marginTop={0}
                        rowBgColor="#000000"
                        rowBgImage=""
                        columnBgImage=""
                        columnBgColor={shouldFocusToGrid ? '#333333' : 'transparent'}
                        selectionColor={shouldFocusToGrid ? '#fff' : 'transparent'}
                        gapBetweenCatTitleAndItemList={15}
                        verticalScrollStartIndex={0} // Adjusted to 0
                        horizontalScrollStartIndex={3}
                        animationSpeed={100}
                        handleBackButton={handleBackButton}
                        handleMarkupGridUPButton={handleMarkupGridUPButton}
                        handleMarkupGridOKButton={handleMarkupGridOKButton}
                        handLeMarkupGridLeftButton={handLeMarkupGridLeftButton}
                        rememberRowFocus={rememberRowFocus}
                        setRememberRowFocus={setRememberRowFocus}
                        rememberColFocus={rememberColFocus}
                        setRememberColFocus={setRememberColFocus}
                    />
                </div>
                <div style={{ position: "absolute" }}>
                    <MenuScreen
                        navigate={navigateToScreen}
                        handleMenuselection={handleMenuselection}
                        shouldCloseMenu={shouldCloseMenu}
                        handleRightButton={handleRightButton}
                        isLogedIn={isLogedIn}
                        appNavigate={navigate}
                        handleLogin={handleLogin}
                        handleLogout={handleLogout}
                        handleExit={handleExit}
                    />

                    <ModalScreen
                        shouldShowError={shouldShowModal}
                        errTitle={errTitle}
                        errDescription={errDescription}
                        errIcon={errIcon}
                        button={button}
                        iconWdth={iconWdth}
                        iconHeight={iconHeight}
                        modalOKButtonHandler={modalOKButtonHandler}
                        modalCANCELButtonHandler={modalCANCELButtonHandler}
                    />
                </div>
            </div>
        );
    } else if (screen === "DetailsScreen") {
        return (
            <DetailsScreen
                handleBack={handleBack}
                data={data}
                isLogedIn={isLogedIn}
                isLiveScreen={true}
                detailToDetail={detailToDetail}
            />
        );
    }

};



export default LiveTv;